// Lib
import { handleActions } from 'redux-actions';

// Actions
import { getUserCandidates } from 'modules/Candidates/actions';
import { setJobBoardStages, clearJobBoard } from './actions';

const initialState: any = {
  loading: false,
  stages: [],
};

export default handleActions(
  {
    [getUserCandidates as any]: state => ({
      ...state,
      loading: true,
    }),
    [setJobBoardStages as any]: (_state, { payload }) => ({
      loading: false,
      stages: payload,
    }),
    [clearJobBoard as any]: () => initialState,
  },
  initialState
);
